var _path, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSports = function SvgSports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.216 18.509A8.97 8.97 0 0 0 21 12q-.002-.982-.202-1.906l-3.964 1.322-1.632 4.079zm-.763.651L14.293 16H9.707l-3.16 3.16A8.96 8.96 0 0 0 12 21a8.96 8.96 0 0 0 5.453-1.84M7.155 11.387l1.643 4.108-3.014 3.014A8.97 8.97 0 0 1 3 12q.002-.995.207-1.928zm-3.68-2.28 4.159 1.386L11.5 7.4V3.014a9.01 9.01 0 0 0-8.025 6.093m12.913 1.403 4.144-1.381A9.01 9.01 0 0 0 12.5 3.014V7.4zM12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "sports_svg__a",
    width: 20,
    height: 20,
    x: 2,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#fff",
    mask: "url(#sports_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.398.841 12 4.36 7.602.84 9.339-3.5h5.323zM23.997 13.377l-4.536-3.337 2.26-5.159 4.643.554 1.377 5.142zM.003 13.377l4.536-3.337L2.28 4.88l-4.643.554-1.377 5.142zM7.67 23.55l-.623-5.597-5.598-.622-1.841 4.297 3.764 3.764zM16.33 23.55l.623-5.597 5.598-.622 1.842 4.297-3.764 3.764z"
  }))));
};
export default SvgSports;